import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { NbCardModule, NbLayoutModule, NbListModule, NbMenuItem, NbMenuModule, NbTabsetModule } from '@nebular/theme';
import { RouterModule } from '@angular/router';
import { StorethemesModule } from '@urbannex/storethemes';
import { SalesOrdersSummaryComponent } from './sales-orders-summary/sales-orders-summary.component';
import { SalesOrdersGraphsComponent } from './sales-orders-graphs/sales-orders-graphs.component';
import { SalesByPeriodGraphsComponent } from './sales-by-period-graphs/sales-by-period-graphs.component';

@Component({
  selector: 'pl-kwik-hub',
  standalone:true,
  imports: [CommonModule,NbLayoutModule,StorethemesModule,RouterModule,NbCardModule,NbTabsetModule,NbMenuModule,SalesOrdersSummaryComponent,SalesOrdersGraphsComponent,SalesByPeriodGraphsComponent],
  templateUrl: './kwik-hub.component.html',
  styleUrls: ['./kwik-hub.component.scss']
})
export class KwikHubComponent {
  appMenuItems:NbMenuItem[] = [
    {
      title:"Store Admin",
      link:'/admin/stores'
    },
    {
      title:"Product Management",
      link:'/admin/products'
    },
    {
      title:"Customers",
      link:'/admin/crm'
    },
    {
      title:"Features Management",
      link:'/admin/features'
    },
    {
      title:"Orders",
      link:'/admin/orders'
    },
    {
      title:"Catalog Management",
      link:'AnotherLink'
    },
    {
      title:"Image Management",
      link:'/admin/img'
    },
    {
      title:"Visual Editor",
      link:'/kve'
    },
    {
      title:"Blog",
      link:'/admin/blog'
    },
  ]

  quickTasks:NbMenuItem[] = [
    {
      title:"Add Products",
      icon:"plus-outline"
    },
    {
      title:"Manage Prices",
      icon:"credit-card-outline",
    },
    {
      title:"Create Promotions"
    },
    {
      title:"Receive Inventory",
      icon:"checkmark-outline"
    },
    {
      title:"Pack Orders",
      icon:"cube-outline"
    },
    {
      title:"Pick Lists",
      icon:"layers-outline",
      link:"/admin/facilities"
    },
    
  ]
}
